<template>
	<div class="main-content-container container-fluid px-4">
		<div>
			<div class="page-header row no-gutters py-4">
				<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				  <span class="text-uppercase page-subtitle">Categorías</span>
				  <h3 class="page-title">Agregar</h3>
			  </div>
		  </div>
		  <div class="row">
        <div class="col-lg-12">
          <div class="card card-small mb-3">
            <div class="card-body">
                <div class="form-group">
                	<input type="text" class="form-control" :class="error.name.status" placeholder="Nombre" v-model="form.name">
                  <div class="invalid-feedback">
                    {{ error.name.message[0] }}
                  </div>
                </div>
                <div class="form-group">
                	<input type="text" class="form-control" placeholder="SLUG o URL amigable" v-model="slug" readonly>
                </div>
                <div class="form-group">
                	<textarea rows="4" class="form-control" :class="error.description.status" placeholder="Descripción" v-model="form.description"></textarea>
                	<div class="invalid-feedback">
										{{ error.description.message[0] }}
                	</div>
                </div>
            </div>
            <div class="card-footer border-top">
            	<button type="submit" class="btn btn-primary" @click.prevent="addCategory" v-if="isLoading==false">
            		Agregar
            	</button>
              <div class="text-left" v-if="isLoading==true">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
          </div>
        </div>
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				form: {
					name: '',
					description: ''
				},
				error: {
					name: {
						status: '',
						message: ''
					},
					description: {
						status: '',
						message: ''
					}
				}
			}
		},

		computed: {
			slug: function() {
				return this.form.name.toLowerCase().split(' ').join('_')
			}
		},

		methods: {
			async addCategory() {
				this.isLoading = true;
				const url = `${process.env.VUE_APP_ROOT_API}/category`;
				const data = {
					user_id: this.$store.state.auth.user.id,
					name: this.form.name,
					slug: this.slug,
					description: this.form.description
				};
				const settings = {
					method: 'POST',
					body: JSON.stringify(data),
					headers: {
						'Content-type': 'application/json'
					}
				};
				const response = await fetch(url, settings);
				const responseData = await response.json();
				const errors = responseData['errors'];
				switch (response.status) {
					case 201:
						this.isLoading = false;
						this.successMessage();
						break;
					case 422: 
						this.isLoading = false;
						this.cleanErrorMessages();
						if(errors.name) {
							this.error.name.status = 'is-invalid';
							this.error.name.message = errors.name;
						}
						if(errors.description) {
							this.error.description.status = 'is-invalid';
							this.error.description.message = errors.description;
						}
						break;
					case 500:
						console.log('Ha ocurrido un error inesperado');
						break;
				}
			},

			successMessage() {
        this.$toasted.show("<i class='fas fa-hashtag'></i> Categoría agregada!", { 
           theme: "toasted-primary", 
           position: "top-right", 
           duration : 2000
        });
        window.scrollTo(0, 0);
        this.cleanInputs();
			},

			cleanInputs() {
				this.form.name = '';
				this.slug = '';
				this.form.description = '';
			},

			cleanErrorMessages() {
				this.error.name.status = '';
				this.error.name.message = '';

				this.error.name.status = '';
				this.error.name.message = '';
			}
		}
	}
</script>